type PandaConsoleMessageLevel = "Warn"|"Error"|"Debug"|"Info";

class PandaConsoleMessageLevels {
	public static WARN:PandaConsoleMessageLevel = "Warn";
	public static ERROR:PandaConsoleMessageLevel = "Error";
	public static DEBUG:PandaConsoleMessageLevel = "Debug";
	public static INFO:PandaConsoleMessageLevel = "Info";
}


class PandaConsoleMessageStyles {
	public static Warn:string = "background: #000000; color: #00ff5c;";
	public static Error:string = "background: #000000; color: #ff0000;";
	public static Debug:string = "background: #5b86ff; color: #000000;";

	public static getStyle(level:PandaConsoleMessageLevel):string {
		let style:string = (<any>PandaConsoleMessageStyles)[level];
		return style;
	}

	public static hasStyle(level:PandaConsoleMessageLevel):boolean {
		let style:string = (<any>PandaConsoleMessageStyles)[level];
		return !!style;
	}
}